// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleViewer = {
  id: "viewer",
  mrn: "//iam.api.mondoo.app/roles/viewer",
  title: "Viewer",
  allowedActions,
} as const;

export type RoleViewer = typeof roleViewer;
